

import React from 'react'
import { LoaderThree } from '../../components/gui/elements/LoaderThree'

export const Loader = ({size="80px", color}) => {
  return (
    <LoaderThree color='#418EEB' size={size} />
  )
}